
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pixelate-image",
      function () {
        return require("private-next-pages/pixelate-image/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pixelate-image"])
      });
    }
  